// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.style_labelVal__IdDey{
  font-weight: 500;
  font-family: "Montserrat", sans-serif;

}
.style_inputField__OUwxY {
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: "Montserrat", sans-serif;

  font-weight: 500;
  padding: 0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid #d3d3d3;
}

.style_inputFieldForPass__BFXf9 {
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: "Montserrat", sans-serif;

  font-weight: 500;
  padding: 0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid #d3d3d3;
}
.style_passWrapper__t6RWq {
  position: relative;
  font-family: "Montserrat", sans-serif;

}
.style_eyeIcon__vkVA3 {
  cursor: pointer;
  position: absolute;
  font-family: "Montserrat", sans-serif;

  top: 5px;
  right: 10px;
}

.style_inputFieldForPass__BFXf9:focus {
  outline: 2px solid rgb(195, 193, 193);
}
.style_inputField__OUwxY:focus {
  outline: 2px solid rgb(195, 193, 193);
}


`, "",{"version":3,"sources":["webpack://./src/commonComponents/InputField/styles/style.module.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,qCAAqC;;AAEvC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,qCAAqC;;EAErC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qCAAqC;;EAErC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,qCAAqC;;AAEvC;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,qCAAqC;;EAErC,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC","sourcesContent":["\n.labelVal{\n  font-weight: 500;\n  font-family: \"Montserrat\", sans-serif;\n\n}\n.inputField {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-family: \"Montserrat\", sans-serif;\n\n  font-weight: 500;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid #d3d3d3;\n}\n\n.inputFieldForPass {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-family: \"Montserrat\", sans-serif;\n\n  font-weight: 500;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid #d3d3d3;\n}\n.passWrapper {\n  position: relative;\n  font-family: \"Montserrat\", sans-serif;\n\n}\n.eyeIcon {\n  cursor: pointer;\n  position: absolute;\n  font-family: \"Montserrat\", sans-serif;\n\n  top: 5px;\n  right: 10px;\n}\n\n.inputFieldForPass:focus {\n  outline: 2px solid rgb(195, 193, 193);\n}\n.inputField:focus {\n  outline: 2px solid rgb(195, 193, 193);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelVal": `style_labelVal__IdDey`,
	"inputField": `style_inputField__OUwxY`,
	"inputFieldForPass": `style_inputFieldForPass__BFXf9`,
	"passWrapper": `style_passWrapper__t6RWq`,
	"eyeIcon": `style_eyeIcon__vkVA3`
};
export default ___CSS_LOADER_EXPORT___;
